import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";

export const FAQ_ITEMS = [
  {
    q: "Is InstaVivah really free?",
    a: "Yes. You can create a matrimonial biodata, preview it in multiple templates, and download it as PDF or DOCX without ever creating an account. Premium features like unlimited interest requests are paid, and clearly marked.",
  },
  {
    q: "Do I need to sign up to make a biodata?",
    a: "No. Guests can build a full biodata and download it. We only ask you to save an account once you're happy with the result — never before.",
  },
  {
    q: "What information is shown publicly on Browse Profiles?",
    a: "Only summary attributes: name, age, gender, religion, caste, city, education and occupation. We never publicly display phone numbers, email, address, date of birth, or photos.",
  },
  {
    q: "How do you keep my phone number and photos private?",
    a: "Contact details and photos are hidden by default. They’re revealed to another member only after both of you accept a mutual interest request.",
  },
  {
    q: "Which biodata templates do you offer?",
    a: "Three heirloom-quality templates: Classic Traditional, Modern Minimal, and Royal Ornate. You can switch templates with a single click and see a live preview as you type.",
  },
  {
    q: "Can I export my biodata as a PDF or Word document?",
    a: "Yes. Both PDF (via WeasyPrint) and DOCX (via python-docx) exports are supported. Files are print-ready and WhatsApp-friendly.",
  },
  {
    q: "How much does Premium cost and what do I get?",
    a: "Premium unlocks unlimited interest requests, priority listing in search results, and advanced filters. See the Premium page for current pricing. Payment is via UPI QR code with manual verification.",
  },
  {
    q: "Can I cancel or get a refund?",
    a: "Yes. Premium has a 7-day satisfaction promise. See our Refund Policy for full details.",
  },
  {
    q: "Is my data safe?",
    a: "Passwords are stored using bcrypt hashing. Sessions use httpOnly cookies. We never sell your data. See our Privacy Policy for details.",
  },
  {
    q: "Which communities do you support?",
    a: "InstaVivah is built for Indian families across Hindu, Muslim, Christian, Sikh, Jain, Buddhist, Parsi, and other communities, with region and caste-friendly filters.",
  },
];

export default function FAQ() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_ITEMS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <div>
      <SEO
        title="Frequently Asked Questions"
        path="/faq"
        description="Answers to common questions about InstaVivah — biodata creation, privacy, PDF download, matrimonial profile, Premium pricing, refunds and more."
        keywords="InstaVivah faq, matrimonial faq, biodata questions, marriage profile help, biodata pdf download"
        jsonLd={jsonLd}
      />
      <Navbar />

      <header className="sb-page-hero text-center">
        <div className="container">
          <div className="sb-kicker mb-2">Help &amp; FAQ</div>
          <h1>Frequently asked questions.</h1>
          <p>Everything you might want to know before creating your first biodata.</p>
        </div>
      </header>

      <main className="container py-5">
        <div className="row g-4">
          <div className="col-lg-8">
            {FAQ_ITEMS.map((f, i) => (
              <details className="sb-faq-item" key={i} data-testid={`faq-item-${i}`}>
                <summary>{f.q}</summary>
                <div className="sb-faq-body">{f.a}</div>
              </details>
            ))}
          </div>

          <aside className="col-lg-4">
            <div className="sb-card">
              <div className="sb-kicker mb-2">Still stuck?</div>
              <h3 className="h5">We’re a message away.</h3>
              <p className="text-muted">
                Email <a href="mailto:hello@instavivah.com">hello@instavivah.com</a>{" "}
                or use the contact form. We reply within one business day.
              </p>
              <Link to="/contact" className="btn btn-outline-primary btn-sm w-100">
                Contact support
              </Link>
              <hr />
              <ul className="list-unstyled sb-footer-list mb-0">
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/refund">Refund Policy</Link></li>
                <li><Link to="/biodata/build">Build a Biodata</Link></li>
                <li><Link to="/browse">Browse Profiles</Link></li>
              </ul>
            </div>
          </aside>
        </div>
      </main>

      <Footer />
    </div>
  );
}
